<template>
  <div class="sidebar" :class="{ open: isOpen }">
    <!-- Welcome message -->
    <div class="text-center py-4">
      <p>
        Hola <b>{{ userName }}</b>
      </p>
      <p class="mt-2">¡Mucha suerte con tu practica de hoy!</p>
    </div>
    <!-- End Welcome message -->

    <div class="d-flex flex-column">
      <!-- Enabled modules -->

      <div class="pt-2 pb-5">
        <div v-for="module in modules" :key="module.id">
          <div v-if="module.hidden == false || userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
            <div >
              <a href="#" v-on:click="updateModule(module)" class="btn btn-primary d-block mb-2">
                <IconifyIcon :icon="icons.bxBulb" height="24" style="display: inline"/>
                {{ module.description }}

              <!-- <b-form-checkbox :disabled="permission()" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'"
              class="button-check" v-model="module.hidden"
              @change="ChangeHidden(module)" name="check-button" switch placeholder="hola">
              </b-form-checkbox> -->


              <toggle-button :disabled="permission()" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'"
              :font-size="10" class="button-check" @change="ChangeHidden(module)"
              :value="module.hidden" color="#cb1a1a !important" :labels="{checked: 'Off', unchecked: 'On'}"
              DEFAULT_LABEL_CHECKED='off'/>

              </a>



            </div>
          </div>
        </div>
      </div>
      <!-- End Enabled modules -->

      <!-- Disabled modules -->
      <div class="border-top py-5">
        <span class="text-center">Próximamente</span>
        <a href="#" class="btn btn-disabled d-block mt-3">
          <IconifyIcon :icon="icons.bxBookReader" height="24" />
          Exámenes de admisión
        </a>
        <a href="#" class="btn btn-disabled d-block mt-3">
          <IconifyIcon :icon="icons.bxAward" height="24" />
          Olimpiadas matemáticas
        </a>
      </div>
      <!-- End Disabled modules -->
    </div>
  </div>
</template>

<script>
import IconifyIcon from "@iconify/vue";
import bxAward from "@iconify/icons-bx/bx-award";
import bxBookReader from "@iconify/icons-bx/bx-book-reader";
import bxBulb from "@iconify/icons-bx/bx-bulb";
import bxX from "@iconify/icons-bx/bx-x";


export default {
  name: "Sidebar",
  components: {
    IconifyIcon,
  },
  props: {
    userName: String,
    isOpen: Boolean,
    modules: []
  },
  mounted() {
    this.userPermission =  localStorage.getItem("role");
  },
  methods: {
    updateModule(event) {
      this.$emit("updateModule", event)
      this.$emit("toogle-menu");
    },
    ChangeHidden(event) {
      this.$emit("changeHiddenButtonModules", event)
      if (this.module.hidden == true) {
        this.color = true;
        this.DEFAULT_LABEL_CHECKED = 'off';
      }
    },
    permission() {
      if (this.userPermission == "ROLE_TEACHER") {
        return true;
      }
    }
  },
  data: () => {
    return {
      userPermission: '',
      userData: {},
      courses: [],
      knowledgeAreas: [],
      icons: {
        bxAward,
        bxBookReader,
        bxBulb,
        bxX,
      },
      openMenu: false,
      color:true,
    };
  },
};
</script>

<style scoped>
.sidebar {
  background-color: #fff;
  padding: 24px 11px 24px;
  text-align: center;
  width: 100%;
  max-width: 420px;
  height: 100%;
  position: fixed;
  z-index: 3;
  border-right: 1px solid #F3F3F3;
  transform: translateX(-100%);
  transition: transform 240ms ease;
}

.sidebar.open {
  box-shadow: 4px 0px 20px rgba(0, 0, 0, 0.14);
  transform: translateX(0);
}

@media screen and (min-width: 768px) {
  .sidebar {
    transform: translateX(0);
    max-width: 264px;
    box-shadow: none;
  }
}

.sidebar .btn {
  font-size: 14px;
  padding: 12px;
  text-align: left;
}
</style>
